import userAuthorizedAxios from "./userAuthorizedAxios";

export const ASK_AI_BETA_TAG = 'ASK_AI_2_BETA';

export default {
  getCustomerAddons: (): Promise<any> => userAuthorizedAxios
    .get(`/api/customer/v1/addons`)
    .then((response) => response.data.tags),
};
